import { RootState } from '../reducers'

export const getListRoles = (state: RootState) => state.roles.listRolesData
export const getRolesToUserId = (state: RootState) => state.roles.rolesUserID
export const getRoleModalVisibility = (name: string) => (state: RootState) =>
  state.roles.modalState[name]
export const getSystemRoleSelected = (state: RootState) =>
  state.roles.roleSelected
export const getIsCreatingRole = (state: RootState) => state.roles.isCreatingRole
export const getIsDeletingRole = (state: RootState) => state.roles.isDeletingRole
export const getIsRenamingRole = (state: RootState) => state.roles.isRenamingRole
export const getRoleProductClaims = (productId: string) => (state: RootState) =>
  state.roles.productClaims[productId]
export const getIsLoadingRoleProductClaims =
  (productId: string) => (state: RootState) =>
    state.roles.loadingProductClaims[productId] || false
export const getRoleClaims = (state: RootState) => state.roles.roleClaims
export const getIsLoadingRoleClaims = (state: RootState) =>
  state.roles.isLoadingRoleClaims
export const getIsSavingRole = (state: RootState) => state.roles.isSavingRole
export const getRoleSaved = (state: RootState) => state.roles.roleSaved
